import { render, staticRenderFns } from "./NewLevelDialog.vue?vue&type=template&id=3ffa5517"
import script from "./new-level-dialog.ts?vue&type=script&lang=ts&external"
export * from "./new-level-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./new-level-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports